import { AxiosResponse } from "axios";
import { axiosInstance, MessageResponse } from "./common";

export enum ParticipantType {
  FORWARDING_AUTHORITY = "FORWARDING_AUTHORITY",
  CASE_DEALING_OFFICER = "CASE_DEALING_OFFICER",
  IO_APPOINTING_AUTHORITY = "IO_APPOINTING_AUTHORITY",
  INVESTIGATOR = "INVESTIGATOR",
  CASE_INITIATOR = "CASE_INITIATOR"
}

export interface Participation {
  participation_id: string;
  participant_type: ParticipantType;
  participant_id: string;
}

export interface AddParticipantRequest {
  participant_type: ParticipantType;
  participant_id: string;
}

export interface AddParticipantResponse {
  participation_id: string;
  participant_type: ParticipantType;
  participant_id: string;
}

export interface UpdateParticipantRequest {
  participant_id: string;
}

const ParticipantsAPI = {
  addParticipant: async (
    caseId: string,
    request: AddParticipantRequest
  ) => {
    const response: AxiosResponse<AddParticipantResponse> =
      await axiosInstance.post(
        `/v1/cases/${caseId}/participants`,
        request
      );

    return response.data;
  },

  updateParticipant: async (
    caseId: string,
    participationId: string,
    request: UpdateParticipantRequest
  ) => {
    const response: AxiosResponse<MessageResponse> =
      await axiosInstance.patch(
        `/v1/cases/${caseId}/participants/${participationId}`,
        request
      );

    return response.data;
  },
};

export default ParticipantsAPI